/**
 * Path Repair Utility
 * 
 * Shared helpers for routing functions.
 */

import { pathBlockedByNodes } from '../pathHelpers';

/**
 * Filter redundant points (same position as previous)
 */
export function filterRedundantPoints(points) {
  return points.filter((p, i) => {
    if (i === 0) return true;
    const prev = points[i - 1];
    return Math.abs(p.x - prev.x) > 0.5 || Math.abs(p.y - prev.y) > 0.5;
  });
}

/**
 * For a vertical segment at X spanning y1..y2, find the nearest clear X
 * that doesn't pass through any obstacle. Searches left and right in small steps.
 */
export function findClearX(x, y1, y2, obstacles) {
  if (!pathBlockedByNodes(x, y1, x, y2, obstacles)) return x;
  
  for (let offset = 10; offset < 800; offset += 10) {
    const xRight = x + offset;
    if (!pathBlockedByNodes(xRight, y1, xRight, y2, obstacles)) return xRight;
    const xLeft = x - offset;
    if (!pathBlockedByNodes(xLeft, y1, xLeft, y2, obstacles)) return xLeft;
  }
  return x;
}

/**
 * For a horizontal segment at Y spanning x1..x2, find the nearest clear Y
 * that doesn't pass through any obstacle. Searches up and down in small steps.
 */
export function findClearYForSegment(y, x1, x2, obstacles) {
  const minX = Math.min(x1, x2);
  const maxX = Math.max(x1, x2);
  if (!pathBlockedByNodes(minX, y, maxX, y, obstacles)) return y;
  
  for (let offset = 10; offset < 800; offset += 10) {
    const yDown = y + offset;
    if (!pathBlockedByNodes(minX, yDown, maxX, yDown, obstacles)) return yDown;
    const yUp = y - offset;
    if (!pathBlockedByNodes(minX, yUp, maxX, yUp, obstacles)) return yUp;
  }
  return y;
}
